import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ErrorPanel, Page } from "@/components/layout/page";
import { RouteTabs } from "@/components/layout/route-tabs";
import { AgentHeader, AgentHeaderSkeleton } from "@/features/agents/agent-header";
import { q } from "@/lib/api";

export const Route = createFileRoute("/_app/agents/$agentId")({
  loader: ({ context, params }) => {
    // Warm the cache; the page renders its own loading state, so don't block navigation on it.
    void context.queryClient.prefetchQuery(q.agent(params.agentId));
  },
  component: AgentLayout,
});

function AgentLayout() {
  const { agentId } = Route.useParams();
  const agent = useQuery(q.agent(agentId));
  const base = `/agents/${agentId}`;

  if (agent.error) {
    return (
      <Page>
        <Link to="/agents" className="mb-3 inline-flex items-center gap-1 text-xs text-fg-3 hover:text-fg">
          <ArrowLeft className="size-3" /> All agents
        </Link>
        <ErrorPanel error={agent.error} reset={() => void agent.refetch()} />
      </Page>
    );
  }

  return (
    <Page>
      {agent.data ? <AgentHeader agent={agent.data} /> : <AgentHeaderSkeleton />}
      <RouteTabs
        tabs={[
          { href: base, label: "Summary", exact: true },
          { href: `${base}/analytics`, label: "Analytics" },
          { href: `${base}/score`, label: "Score" },
          { href: `${base}/coverage`, label: "Coverage" },
          { href: `${base}/profile`, label: "Risk profile" },
          { href: `${base}/authority`, label: "Authority" },
          { href: `${base}/versions`, label: "Versions" },
        ]}
      />
      <Outlet />
    </Page>
  );
}
